const slug = "b-timeline";

export const dashboardInfo = (info) => {
  const { version, isPremium, hasPro, licenseActiveNonce } = info;

  const proSuffix = isPremium ? ' Pro' : '';
 
  return {
    name: `Timeline${proSuffix}`,
    displayName: `Timeline${proSuffix} - Vertical and Horizontal Timeline Layouts`,
    description: "Timeline is a liteweight WordPress plugin that lets you create and display timeline in any Posts / Pages/ Widget .The plugin is very easy to use and anyone can use the plugin easily without any technical knowledge.",
    slug,
    version,
    isPremium,
    hasPro,
    displayOurPlugins: true,
    media: {
      logo: `https://ps.w.org/${slug}/assets/icon-128x128.png`,
      banner: `https://ps.w.org/${slug}/assets/banner-772x250.png`,
      thumbnail: `https://bplugins.com/wp-content/themes/b-technologies/assets/images/products/timeline-block-block.png`,
      // proThumbnail: `https://bplugins.com/wp-content/themes/b-technologies/assets/images/products/${slug}-pro.png`,
      // video: 'https://www.youtube.com/watch?v=milYZrqLJsE',
      // isYoutube: true
    },
    pages: {
      org: `https://wordpress.org/plugins/${slug}/`,
      landing: `https://bplugins.com/products/${slug}/`,
      // docs: `https://bplugins.com/docs/${slug}/`,
      pricing: `https://bplugins.com/products/${slug}/pricing`,
    },
    freemius: {
      product_id: '17342',
      plan_id: '28900',
      public_key: 'pk_624005a9d0c56ff46db6602f5f730',
    },
    licenseActiveNonce,
    changelogs: [
      {
        version: "2.0.2 - 11 April 2026",
        type: "fix",
        list: ["Fixed Issues", "Updated Pro Version- Add New Theme & Animation Features"],
      },
      {
        version: "2.0.1 - 24 February 2026 ",
        type: "update",
        list: ["Redesigned the full settings layout and improved the admin dashboard interface","Optimized files and enhanced overall code readability for better maintainability.", "Optimized plugin files"],
      },
      {
        version: "2.0.0 - 25 January 2026",
        type: "fix",
        list: ["Fixed horizontal timeline issue", "Optimized plugin files"],
      },
      {
        version: "1.1.9 - 15 November 2025",
        type: "fix",
        list: ["Fixed Issues"],
      },
      {
        version: "1.1.8 - 5 November 2025 ",
        type: "update",
        list: ["Updated dashboard"],
      },
      {
        version: "1.1.7 - 21 October 2025",
        type: "fix",
        list: ["Fixed conflict issues and updated demos"],
      },
      {
        version: "1.1.6 - 16 September 2025",
        type: "new",
        list: ["Add Modern Dashboard"],
      },
      {
        version: "1.1.5 - 19 May, 2025",
        type: "fix",
        list: ["Fixed Mobile view issue"],
      },
      {
        version: "1.1.4 - 24 April, 2025",
        type: "fix",
        list: ["Fixed textdomain issues and seo issue"],
      },
      {
        version: "1.1.2 - 24 April, 2025",
        type: "fix",
        list: ["Fixed textdomain issues"],
      },
      {
        version: "1.1.2 - 20 March, 2025",
        type: "fix",
        list: ["Fixed Issues"],
      },
      {
        version: "1.1.1 - 11 March, 2025",
        type: "fix",
        list: ["Fixed Issues"],
      },
    ],
    proFeatures: [
      "ShortCode to use Timeline Block anywhere.",
      "Nine extra professional theme designs.",
      "Classic Editor for advanced formatting.",
      "Customizable and styled timeline icons.",
      "Advanced tools for ultimate design control.",
      "Add New Animation Features"
    ],
    startButton: {
      label: 'Start Now',
      url: `wp-admin/post-new.php?post_type=btimeline`
    }
  }
}

export const demoInfo = {
  allInOneLabel: 'See All Demos',
  allInOneLink: "https://bblockswp.com/demo/timeline-block-all-demos/",
  demos: [
    {
      icon: "",
      title: "Vertical Timeline",
      description: "",
      category: "",
      type: "iframe",
      url: "https://demo.bplugins.com/demo/vertical-timeline/",
    },
    {
      icon: "",
      title: "Horizontal Timeline",
      description: "",
      category: "",
      type: "iframe",
      url: "https://demo.bplugins.com/demo/horizontal-timeline/",
    },
    {
      icon: "",
      title: "Block Default Timeline",
      description: "",
      category: "",
      type: "iframe",
      url: "https://bblockswp.com/demo/3111/",
    },
    {
      icon: "",
      title: "Block Customized Timeline",
      description: "",
      category: "",
      type: "iframe",
      url: "https://bblockswp.com/demo/customize-timeline-default-theme/",
    },
    {
      icon: "",
      title: "Tamplate 1(Accordion Timeline)",
      description: "",
      category: "",
      type: "iframe",
      url: "https://bblockswp.com/demo/accordion-timeline-with-classic-editor-pro/",
    },
    {
      icon: "",
      title: "Tamplate 2(Vertical & Horizontal Options)",
      description: "",
      category: "",
      type: "iframe",
      url: "https://bblockswp.com/demo/timeline-with-icon-and-date-pro/",
    },
    {
      icon: "",
      title: "Tamplate 3",
      description: "",
      category: "",
      type: "iframe",
      url: "https://bblockswp.com/demo/theme-3-pro/",
    },
    {
      icon: "",
      title: "Tamplate 4",
      description: "",
      category: "",
      type: "iframe",
      url: "https://bblockswp.com/demo/theme-4-pro/",
    },
    {
      icon: "",
      title: "Tamplate 5",
      description: "",
      category: "",
      type: "iframe",
      url: "https://bblockswp.com/demo/timeline-block-theme-5-pro/",
    },
    {
      icon: "",
      title: "Tamplate 6",
      description: "",
      category: "",
      type: "iframe",
      url: "https://bblockswp.com/demo/timeline-block-theme-6-pro/",
    },
    {
      icon: "",
      title: "Template 7",
      description: "",
      category: "",
      type: "iframe",
      url: "https://bblockswp.com/demo/timeline-block-theme-7-pro/",
    },
  ],
}

export const pricingInfo = {
  logo: `https://ps.w.org/${slug}/assets/icon-128x128.png`, // Optional
  pluginId: 17342,
  planId: 28900,
  licenses: [
    1,
    3,
    null
  ],
  button: {
    label: 'Buy Now ➜'
  },
  featured: {
    selected: 3, // choose from licenses item
  }
}
